const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    clientUrl: "https://client.trackmydoc.com",
  },
  "northernimmigration.co.in": {
    name: "Northern Immigration",
    domainName: "northernimmigration.co.in",
    logo: "/assets/logo/logo.png",
    favicon: "/assets/logo/favicon.ico",
    clientUrl: "https://client.northernimmigration.co.in",
  }
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
